export default {
    title: 'Your organization competencies',
    subtitle:
        'When an evaluation includes a competency, its assessment questions are added automatically to the questionnaire.',
    statusLabel: 'Status',
    exploreCompetencies: 'Explore competencies',
    assignToEmployees: {
        cardAction: 'Assign to employees',
        title: 'Assign "{{name}}" to employees',
        subtitle: 'Pick the employees who will receive this competency.',
        steps: {
            indicator: '1 {{method}} › 2 {{detail}} › 3 {{review}}',
            method: 'Method',
            detail: 'Details',
            review: 'Review',
        },
        method: {
            heading: 'Choose the assignment method',
            individual: {
                label: 'Individual assignment',
                description: 'Pick the employees who will receive this competency one by one.',
            },
            rule: {
                label: 'Rule-based assignment',
                description:
                    'Target employees by their attributes (department, job title, level, etc.).',
            },
            profile: {
                label: 'Profile-based assignment',
                description:
                    'Add the competency to one or more profiles. All their current and future employees will get it.',
            },
        },
        individual: {
            heading: 'Find employees',
            searchPlaceholder: 'Search by name…',
            selectedCount: '{{count}} selected',
            selectedCount_one: '{{count}} selected',
            selectedCount_other: '{{count}} selected',
            noJobDepartment: 'No job title or department',
            empty: 'No employees found.',
            loadError: 'Unable to load employees.',
        },
        rule: {
            heading: 'Build assignment rules',
            description: 'Define conditions to automatically target employees.',
            attribute: 'Attribute',
            customAttribute: 'Custom attribute',
            subtitle: 'Filter employees by one or more attributes.',
            attributeLabel: 'Attribute',
            attributePlaceholder: 'Select attribute',
            attributeRequired: 'Choose an attribute to target employees.',
            valuesRequired: 'Choose at least one value for this attribute.',
            valuesLabel: 'Values',
            valuesPlaceholder: 'Type to filter...',
            noValues: 'No values available for this attribute.',
            addAttribute: 'Add attribute',
            matchedCount: '{{count}} employees match these rules',
        },
        profile: {
            heading: 'Select profiles',
            helper: 'The competency will be added to the selected profiles; all their current and future employees will get it.',
            searchPlaceholder: 'Search profiles…',
            empty: 'No profiles found.',
            skillCount: '{{count}} competencies in this profile',
            skillCount_one: '{{count}} competency in this profile',
            skillCount_other: '{{count}} competencies in this profile',
            memberCount: '{{count}} employees',
            memberCount_one: '{{count}} employee',
            memberCount_other: '{{count}} employees',
            memberCountCurrent: '{{count}} employees currently',
            memberCountCurrent_one: '{{count}} employee currently',
            memberCountCurrent_other: '{{count}} employees currently',
            sourceLabel: 'Source profiles',
            sourcePlaceholder: 'Select one or more profiles',
        },
        review: {
            summary: '{{count}} employees will receive this competency',
            summary_one: '{{count}} employee will receive this competency',
            summary_other: '{{count}} employees will receive this competency',
            empty: 'No employees targeted. Go back to adjust your selection.',
            success: '{{count}} employees received this competency',
            success_one: '{{count}} employee received this competency',
            success_other: '{{count}} employees received this competency',
            successProfile: 'Competency added to {{count}} profiles',
            successProfile_one: 'Competency added to {{count}} profile',
            successProfile_other: 'Competency added to {{count}} profiles',
            competencyHeading: 'Competency to assign',
            employeesHeading: 'Employees',
            profilesHeading: 'Profiles',
            willReceiveIndividual: 'This competency will be assigned to {{count}} employees.',
            willReceiveIndividual_one: 'This competency will be assigned to {{count}} employee.',
            willReceiveIndividual_other: 'This competency will be assigned to {{count}} employees.',
            willReceiveRule: 'This competency will be assigned to {{count}} matching employees.',
            willReceiveRule_one: 'This competency will be assigned to {{count}} matching employee.',
            willReceiveRule_other:
                'This competency will be assigned to {{count}} matching employees.',
            willReceiveWithAlready: '{{sentence}} {{already}}',
            alreadyHaveClause: 'Of these, {{count}} already have this competency.',
            alreadyHaveClause_one: 'Of these, {{count}} already has this competency.',
            alreadyHaveClause_other: 'Of these, {{count}} already have this competency.',
            profileDescription:
                'This competency will be added to the following profiles: {{profiles}}. All current and future members of these profiles will get it.',
            profileDescription_one:
                'This competency will be added to the {{profiles}} profile. All current and future members of this profile will get it.',
            profileDescription_other:
                'This competency will be added to the following profiles: {{profiles}}. All current and future members of these profiles will get it.',
            alreadyAssigned: '{{count}} employees already have this competency',
            alreadyAssigned_one: '{{count}} employee already has this competency',
            alreadyAssigned_other: '{{count}} employees already have this competency',
        },
        actions: {
            back: 'Back',
            next: 'Next',
            review: 'Review',
            confirm: 'Assign ({{count}})',
            confirmProfile: 'Assign ({{count}} profiles)',
            confirmProfile_one: 'Assign ({{count}} profile)',
            confirmProfile_other: 'Assign ({{count}} profiles)',
            cancel: 'Cancel',
        },
    },
    explore: {
        title: 'Competency library',
        subtitle: 'Explore and import predefined competencies into your system',
        searchPlaceholder: 'Search a competency…',
        selectedCount: '{{count}} selected',
        selectedCount_one: '{{count}} selected',
        selectedCount_other: '{{count}} selected',
        importedCountLabel: '{{count}} competencies imported',
        importedCountLabel_one: '{{count}} competency imported',
        importedCountLabel_other: '{{count}} competencies imported',
        empty: 'No competencies found.',
        loadError: 'Unable to load the competency library.',
        importWithCount: 'Import ({{count}})',
        cancel: 'Cancel',
        close: 'Close',
        success: 'Imported {{count}} competencies',
        success_one: 'Imported {{count}} competency',
        success_other: 'Imported {{count}} competencies',
        alreadyImported: 'Already imported',
    },
    questionCount: '{{count}} questions',
    questionCount_one: '{{count}} question',
    questionCount_other: '{{count}} questions',
    retry: 'Retry',
    tabs: {
        competencies: 'Competencies',
        profiles: 'Profiles',
        levels: 'Levels',
        translations: 'Translations',
    },
    competencyCount: '{{count}} competencies',
    competencyCount_one: '{{count}} competency',
    competencyCount_other: '{{count}} competencies',
    assignedSummary: 'Assigned to {{profiles}} and {{employees}}',
    assignedProfiles: '{{count}} profiles',
    assignedProfiles_one: '{{count}} profile',
    assignedProfiles_other: '{{count}} profiles',
    assignedEmployees: '{{count}} employees',
    assignedEmployees_one: '{{count}} employee',
    assignedEmployees_other: '{{count}} employees',
    disabled: 'Disabled',
    emptyState: 'No competencies yet',
    emptyGroup: 'No competencies in this group yet',
    emptyGroupHint: 'Add competencies to this group so they can be assessed in evaluations.',
    emptyGroupCta: 'Add a competency',
    noResults: 'No competencies match your filters',
    error: 'Unable to load competencies.',
    searchPlaceholder: 'Search competencies',
    statusFilter: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
    },
    add: {
        button: 'Add',
        competency: 'Competency',
        group: 'Group',
    },
    actions: {
        move: 'Move to a group',
        viewAssignedProfiles: 'View assigned profiles',
        competencyDeactivatedTooltip:
            'This competency is deactivated. Reactivate it before assigning it to employees.',
        groupDeactivatedTooltip: 'The group is deactivated. Activate the group first.',
    },
    assignedProfilesModal: {
        title: 'Assigned profiles',
        subtitle: 'Profiles containing the competency {{name}}.',
        view: 'View',
        viewEmployees: 'View employees',
        back: 'Back',
        individualRow: 'Added individually · {{count}} employees outside any profile',
        individualRow_one: 'Added individually · {{count}} employee outside any profile',
        individualRow_other: 'Added individually · {{count}} employees outside any profile',
        individualSectionTitle: 'Added individually',
        profileMeta: '{{competencies}} · {{employees}}',
        profileCompetencyCount: '{{count}} competencies',
        profileCompetencyCount_one: '{{count}} competency',
        profileCompetencyCount_other: '{{count}} competencies',
        profileEmployeeCount: '{{count}} employees',
        profileEmployeeCount_one: '{{count}} employee',
        profileEmployeeCount_other: '{{count}} employees',
        profilesEmpty: 'No profile contains this competency.',
        employeesEmpty: 'No employees.',
        employeesError: 'Unable to load employees.',
        noJobDepartment: 'No job title or department',
    },
    questions: {
        title: 'Assessment questions for this competency:',
        empty: 'No questions yet for this competency.',
        standardQuestionNotice:
            'You haven’t created a custom question for this competency. The standard question will therefore be used to evaluate it: “Do you feel <bold>{{firstNamePlaceholder}}</bold> demonstrates the <bold>{{name}}</bold> competency?”',
        fallbackQuestionInfo:
            'The fallback question is generated automatically during the assessment and cannot be edited here. If you add a custom question, the fallback will no longer be used.',
        firstNamePlaceholder: '[first name]',
        defaultSatisfaction: {
            best: 'Exceptional',
            high: 'Above expectations',
            mid: 'Meets expectations',
            low: 'Below expectations',
            worst: 'Far below expectations',
        },
        defaultScaleFrom: 'Does not meet expectations',
        defaultScaleTo: 'Meets expectations',
        loadError: 'Unable to load questions.',
        add: 'Add a question',
        active: 'Active',
        inactive: 'Inactive',
        activate: 'Activate',
        deactivate: 'Deactivate',
        saved: 'Questions saved',
        move: {
            action: 'Move to another competency',
            title: 'Move "{{name}}"',
            targetLabel: 'Target competency',
            targetPlaceholder: 'Select a competency',
            confirm: 'Move',
            success: 'Question moved',
        },
        editTitle: 'Edit the question',
        createTitle: 'New question',
        labelLabel: 'Question',
        labelPlaceholder: 'Enter the question',
        typeLabel: 'Question type',
        type: {
            rating: 'Scale',
            multipleChoice: 'Multiple choice',
            satisfaction: 'Satisfaction (😊)',
            yesNo: 'Yes / No',
        },
        scale: {
            title: 'Scale format',
            from: 'From',
            to: 'To',
            fromLabelPlaceholder: 'Low label',
            toLabelPlaceholder: 'High label',
        },
        choices: {
            title: 'Multiple choice options',
            helper: 'Add and customize the answer options. Drag to reorder.',
            optionPlaceholder: 'Option {{index}}',
            add: 'Add an option',
        },
        satisfaction: {
            title: 'Satisfaction scale',
            helper: 'Customize the label shown under each emoji.',
        },
        yesNo: {
            title: 'Yes / No',
            helper: 'The employee will answer with Yes or No.',
            yes: 'Yes',
            no: 'No',
        },
        validation: {
            labelRequired: 'The question text is required',
            scaleLabelRequired: 'This label is required',
        },
    },
    groupForm: {
        createTitle: 'Create a competencies group',
        editTitle: 'Edit the competencies group',
        nameLabel: 'Name',
        namePlaceholder: 'Group name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Group description',
        description: 'Edit the group name and description',
        descriptionHelper: 'Add a new group to organize your competencies',
    },
    competencyForm: {
        createTitle: 'Add a competency',
        editTitle: 'Edit competency',
        nameLabel: 'Name',
        namePlaceholder: 'Competency name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Competency description',
        groupLabel: 'Group',
        groupPlaceholder: 'Select a group',
        noGroupAdded: 'No group added',
    },
    deleteGroup: {
        title: 'Delete group « {{name}} »',
        warning:
            'This action is irreversible and applies retroactively. Any selected replacements will be applied before the deletion.',
        impactSummary:
            'This group contains {{competencies}}. {{assigned}} ({{assignments}}). Choose a replacement for each competency, or leave "No replacement" to remove it without replacement.',
        competency: 'Competency',
        employees: 'Employees',
        replaceWith: 'Replace with',
        replacePlaceholder: 'Select a replacement competency',
        noReplacement: 'No replacement',
        assignedCompetencies: '{{count}} are assigned to employees',
        assignedCompetencies_one: '{{count}} is assigned to an employee',
        assignedCompetencies_other: '{{count}} are assigned to employees',
        totalAssignments: '{{count}} assignments in total',
        totalAssignments_one: '{{count}} assignment in total',
        totalAssignments_other: '{{count}} assignments in total',
        confirm: 'Delete permanently',
        noAssignedEmployeesTooltip:
            'No employees are assigned to this competency, so no replacement is needed.',
    },
    deleteCompetency: {
        title: 'Delete competency',
        message: 'Are you sure you want to delete this competency?',
    },
    assignGroup: {
        action: 'Assign the group',
        noCompetenciesTooltip: 'The group has no active competencies to assign.',
        title: 'Assign the group "{{name}}"',
        subtitle: 'All {{count}} active competencies of the group will be assigned.',
        subtitle_one: 'The active competency of the group will be assigned.',
        subtitle_other: 'All {{count}} active competencies of the group will be assigned.',
        success: 'Group assigned to {{count}} employees',
        success_one: 'Group assigned to {{count}} employee',
        success_other: 'Group assigned to {{count}} employees',
        successProfile: 'Group added to {{count}} profiles',
        successProfile_one: 'Group added to {{count}} profile',
        successProfile_other: 'Group added to {{count}} profiles',
    },
    deactivateGroup: {
        title: 'Deactivate group « {{name}} »',
        warning:
            'This action applies to future additions only. Any selected replacements will be applied before the deactivation.',
        impactSummary:
            'This group contains {{competencies}}. {{assigned}} ({{assignments}}). Choose a replacement for each competency, or leave "No replacement" to deactivate it without replacement.',
        competency: 'Competency',
        employees: 'Employees',
        replaceWith: 'Replace with',
        replacePlaceholder: 'Select a replacement competency',
        noReplacement: 'No replacement',
        assignedCompetencies: '{{count}} are assigned to employees',
        assignedCompetencies_one: '{{count}} is assigned to an employee',
        assignedCompetencies_other: '{{count}} are assigned to employees',
        totalAssignments: '{{count}} assignments in total',
        totalAssignments_one: '{{count}} assignment in total',
        totalAssignments_other: '{{count}} assignments in total',
        confirm: 'Deactivate',
    },
    cascade: {
        loading: 'Calculating impact…',
        loadError: 'Unable to calculate the impact.',
        impact: '{{profiles}} profiles and {{employees}} employees affected',
        affectedProfiles: 'Affected profiles:',
        replaceLabel: 'Replace with another competency (optional)',
        replacePlaceholder: 'No replacement',
        noReplacementOption: 'None, the competency will be removed without replacement',
        cancel: 'Cancel',
        title: {
            deactivate: 'Deactivate the competency',
            delete: 'Delete the competency',
        },
        warningHeading: {
            deactivate: 'This action applies to future additions only',
            delete: 'This action is irreversible and applies retroactively',
        },
        warning: {
            deactivate:
                'The competency will no longer be assessed in the future. It stays in the profiles but becomes inactive. This action is reversible: you can reactivate it at any time.',
            delete: 'Permanent deletion. The competency will be removed from the affected profiles and employees. This action cannot be undone.',
        },
        confirm: {
            deactivate: 'Deactivate',
            delete: 'Delete',
        },
        success: {
            deactivate: 'Competency deactivated',
            delete: 'Competency deleted',
        },
    },
    moveCompetency: {
        title: 'Move "{{name}}"',
        targetLabel: 'Target group',
        targetPlaceholder: 'Select a group',
        confirm: 'Move',
    },
    validation: {
        groupNameRequired: 'Group name is required',
        competencyNameRequired: 'Competency name is required',
        competencyGroupRequired: 'A group is required',
        nameTooLong: 'The name must not exceed 100 characters',
        descriptionTooLong: 'The description must not exceed 500 characters',
        groupNameDuplicate: 'A group with this name already exists',
        competencyNameDuplicate: 'A competency with this name already exists in this group',
        duplicateNameInGroup: 'A competency with this name already exists in the target group',
    },
    toast: {
        groupCreated: 'Group created',
        groupUpdated: 'Group updated',
        groupDeleted: 'Group deleted',
        groupDeactivated: 'Group "{{name}}" deactivated',
        groupActivated: 'Group "{{name}}" activated',
        groupActivatedWithRemaining:
            'Group "{{name}}" activated. {{count}} competencies remain individually deactivated.',
        groupActivatedWithRemaining_one:
            'Group "{{name}}" activated. {{count}} competency remains individually deactivated.',
        groupActivatedWithRemaining_other:
            'Group "{{name}}" activated. {{count}} competencies remain individually deactivated.',
        competencyCreated: 'Competency created',
        competencyUpdated: 'Competency updated',
        competencyDeleted: 'Competency deleted',
        competencyMoved: 'Competency moved',
        competencyActivated: 'Competency activated',
        competencyDeactivated: 'Competency deactivated',
    },
    profiles: {
        title: 'Competency profiles',
        create: 'Create a profile',
        empty: 'No profiles yet',
        loadError: 'Unable to load profiles.',
        competencyCount: '{{count}} competencies',
        competencyCount_one: '{{count}} competency',
        competencyCount_other: '{{count}} competencies',
        assignedCount: 'Assigned to {{count}} profiles',
        assignedCount_one: 'Assigned to {{count}} profile',
        assignedCount_other: 'Assigned to {{count}} profiles',
        addCompetency: 'Add a competency',
        ungrouped: 'Ungrouped',
        remove: 'Remove',
        editDescription: 'Update the profile name and description',
        menu: {
            edit: 'Edit the profile',
            delete: 'Delete the profile',
            assign: 'Assign the profile',
            viewAssignedEmployees: 'View assigned employees',
            deactivate: 'Deactivate the profile',
            activate: 'Reactivate the profile',
        },
        employeeCount: '{{count}} employees',
        employeeCount_one: '{{count}} employee',
        employeeCount_other: '{{count}} employees',
        assignedEmployees: {
            title: 'Employees assigned to "{{name}}"',
            subtitle: '{{count}} employees currently hold this profile.',
            subtitle_one: '{{count}} employee currently holds this profile.',
            subtitle_other: '{{count}} employees currently hold this profile.',
            unassign: 'Unassign',
            toast: {
                unassigned: '{{name}} unassigned from the profile',
            },
        },
        assign: {
            title: 'Assign the profile "{{name}}"',
            steps: {
                indicator: '1 {{method}} › 2 {{detail}} › 3 {{review}}',
                method: 'Method',
                detail: 'Details',
                review: 'Review',
            },
            method: {
                individual: {
                    label: 'Individual',
                    description: 'Pick the employees who will receive this profile one by one.',
                },
                rule: {
                    label: 'By rule',
                    description:
                        'Target employees by their attributes (department, job title, level, etc.).',
                },
                profile: {
                    label: 'By profile',
                    description:
                        'Reuse the employees already assigned to one or more other profiles.',
                },
            },
            individual: {
                searchPlaceholder: 'Search by name or email…',
                selectedCount: '{{count}} selected',
                selectedCount_one: '{{count}} selected',
                selectedCount_other: '{{count}} selected',
                empty: 'No employees found.',
                loadError: 'Unable to load employees.',
            },
            rule: {
                helper: 'Target employees by their attributes.',
                attributePlaceholder: 'Add an attribute',
                matchedCount: '{{count}} employees match',
                matchedCount_one: '{{count}} employee matches',
                matchedCount_other: '{{count}} employees match',
            },
            profile: {
                helper: 'Targeted employees are the union of the selected profiles.',
                sourceLabel: 'Source profiles',
                sourcePlaceholder: 'Select one or more profiles',
            },
            review: {
                alreadyAssignedNote:
                    '{{count}} of them already have another profile; assigning will replace it',
                alreadyAssignedNote_one:
                    '{{count}} of them already has another profile; assigning will replace it',
                alreadyAssignedNote_other:
                    '{{count}} of them already have another profile; assigning will replace it',
                alreadyAssignedClause: '{{count}} already have another profile',
                alreadyAssignedClause_one: '{{count}} already has another profile',
                alreadyAssignedClause_other: '{{count}} already have another profile',
                summary: '{{count}} employees will be assigned to this profile',
                summary_one: '{{count}} employee will be assigned to this profile',
                summary_other: '{{count}} employees will be assigned to this profile',
                empty: 'No employees targeted. Go back to adjust your selection.',
                success: 'Profile assigned to {{count}} employees',
                success_one: 'Profile assigned to {{count}} employee',
                success_other: 'Profile assigned to {{count}} employees',
                ruleDescription: 'This profile will be assigned to {{count}} matching employees.',
                ruleDescription_one:
                    'This profile will be assigned to {{count}} matching employee.',
                ruleDescription_other:
                    'This profile will be assigned to {{count}} matching employees.',
                profileDescription:
                    'This profile will be assigned to the {{count}} employees of the selected profiles.',
                profileDescription_one:
                    'This profile will be assigned to the {{count}} employees of the selected profile.',
                profileDescription_other:
                    'This profile will be assigned to the {{count}} employees of the selected profiles.',
                individualDescription:
                    'This profile will be assigned to {{count}} selected employees.',
                individualDescription_one:
                    'This profile will be assigned to {{count}} selected employee.',
                individualDescription_other:
                    'This profile will be assigned to {{count}} selected employees.',
            },
            actions: {
                back: 'Back',
                next: 'Next',
                confirm: 'Assign ({{count}})',
                cancel: 'Cancel',
            },
        },
        form: {
            createTitle: 'Create a profile',
            editTitle: 'Edit the profile',
            nameLabel: 'Name',
            namePlaceholder: 'Profile name',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Profile description',
        },
        delete: {
            title: 'Delete profile',
            message: 'Are you sure you want to delete this profile?',
        },
        deactivateModal: {
            title: 'Deactivate the profile',
            message: 'Are you sure you want to deactivate the profile "{{profile}}"?',
            impactTitle: 'Impact on assignments',
            impactBody:
                'A deactivated profile is hidden from new assignments and can no longer be assigned to employees. Employees who already have this profile keep it, and their assessments are unaffected. You can reactivate the profile at any time.',
            confirm: 'Deactivate the profile',
        },
        removeModal: {
            title: 'Remove the competency from the profile',
            message:
                'Are you sure you want to remove "{{competency}}" from the profile "{{profile}}"?',
            impactTitle: 'Impact on employees',
            impactBody:
                'This competency will be removed from the profile of the {{count}} employees assigned this profile. If the competency was added manually to an employee, it stays in their individual profile.',
            impactBody_one:
                'This competency will be removed from the profile of the {{count}} employee assigned this profile. If the competency was added manually to an employee, it stays in their individual profile.',
            impactBody_other:
                'This competency will be removed from the profile of the {{count}} employees assigned this profile. If the competency was added manually to an employee, it stays in their individual profile.',
            confirm: 'Remove the competency',
        },
        addModal: {
            title: 'Add a competency',
            competencyLabel: 'Competency',
            competencyPlaceholder: 'Select a competency',
            priorityLabel: 'Priority competency',
            confirm: 'Add',
            allAdded: 'All competencies are already in this profile.',
        },
        wizard: {
            title: 'Create a profile',
            creating: 'Creating competency profile',
            pageBack: 'Back',
            previous: 'Previous',
            next: 'Next',
            finish: 'Create the profile',
            stepSelect: 'Select competencies',
            stepReview: 'Review',
            selectTitle: 'Select competencies',
            reviewTitle: 'Review',
            reviewSubtitle: 'Review the profile before creating it.',
            assignNotice:
                'This profile will stay available for all future employees, and it will be assigned immediately to {{name}}.',
            selectedCount: '{{count}} competencies selected',
            selectedCount_one: '{{count}} competency selected',
            selectedCount_other: '{{count}} competencies selected',
            selectedInGroup: '{{count}} selected',
            selectedInGroup_one: '{{count}} selected',
            selectedInGroup_other: '{{count}} selected',
            markPriority: 'Mark as priority',
            markedAsPriority: 'Marked as a priority',
        },
        levels: {
            Junior: 'Junior',
            Evolution: 'Evolution',
            Satisfactory: 'Satisfactory',
            Advanced: 'Advanced',
            Expert: 'Expert',
        },
        priority: 'Priority',
        validation: {
            nameRequired: 'Profile name is required',
        },
        toast: {
            created: 'Profile created',
            updated: 'Profile updated',
            deleted: 'Profile deleted',
            activated: 'Profile reactivated',
            deactivated: 'Profile deactivated',
            duplicateName: 'A profile with this name already exists',
        },
    },
    levels: {
        title: 'Proficiency levels',
        subtitle:
            'Customize the competency rating levels. You can have between {{min}} and {{max}}.',
        labelPlaceholder: 'Level label',
        addLevel: 'Add a level',
        addConfirm: {
            title: 'Add a proficiency level?',
            message:
                'Assessments already recorded keep the level they were given: adding a level only changes the scale for the evaluations to come. Do you want to continue?',
            confirm: 'Add the level',
        },
        removeConfirm: {
            title: 'Remove this proficiency level?',
            message:
                'Removing a level automatically updates all past assessments: every score is reclassified into the new level scale based on its percentage. Do you want to continue?',
            confirm: 'Remove the level',
        },
        remove: 'Remove this level',
        save: 'Save',
        saving: 'Saving…',
        cancel: 'Cancel',
        saved: 'Proficiency levels updated',
        saveError: 'Error while saving the levels',
        nameRequired: 'The level name is required',
        nameTooLong: 'This field cannot exceed 100 characters.',
        descriptionTooLong: 'This field cannot exceed 500 characters.',
        loadError: 'Unable to load the proficiency levels.',
        retry: 'Try again',
        loading: 'Loading levels…',
        uploadInvalidType: 'Please choose an image file (SVG, PNG, JPG…).',
        uploadTooLarge: 'The icon must be smaller than 100 KB.',
        uploadError: 'Unable to read the file.',
        importIcon: 'Import an icon…',
        iconColor: 'Icon color',
        customColor: 'Custom color',
        icons: {
            achieved: 'Mastered',
            almostAchieved: 'Almost there',
            evolution: 'In progress',
            notMet: 'Not met',
            star: 'Star',
            target: 'Target',
            award: 'Medal',
            bolt: 'Lightning',
            trophy: 'Trophy',
            medal: 'Medal',
            crown: 'Crown',
            flag: 'Flag',
            sparkles: 'Excellence',
            thumbsUp: 'Thumbs up',
            trendingUp: 'Progress',
            checkCheck: 'Validated',
            rocket: 'Lift-off',
            lightbulb: 'Idea',
            graduationCap: 'Graduate',
            gauge: 'Gauge',
            barChart: 'Bar chart',
            podium: 'Podium',
            ribbon: 'Ribbon',
            certificate: 'Certificate',
            key: 'Key',
            compass: 'Compass',
            summit: 'Summit',
            seedling: 'Growth',
            shieldCheck: 'Verified',
            checkCircle: 'Check circle',
            alert: 'Alert',
            warning: 'Warning',
        },
    },
    performanceScoreLevels: {
        title: 'Performance Score Levels',
        subtitle:
            "The employee's performance score is automatically offered to the {{managerLabel}} during their evaluation, based on the competency score. The number of competency levels may be different from the number of performance levels.",
        addLevel: 'Add a level',
        save: 'Save',
        saving: 'Saving…',
        cancel: 'Cancel',
        saved: 'Performance score levels updated',
        saveError: 'Error while saving the performance score levels',
        loading: 'Loading performance score levels…',
        loadError: 'Unable to load the performance score levels.',
        retry: 'Try again',
        remove: 'Remove this level',
        tier: 'Tier',
        titlePlaceholder: 'Level title',
        descriptionPlaceholder: 'Level description',
        minScoreLabel: 'Minimum score',
        validation: {
            titleRequired: 'Each level must have a title.',
            iconRequired: 'Each level must have an icon.',
            colorRequired: 'Each level must have a color.',
            colorInvalid: 'Each level color must be a valid hex value.',
            minScoreInteger: 'Minimum score must be an integer.',
            minScoreRange: 'Minimum score must be between 0 and 100.',
            levelCountMin: 'You must define at least {{min}} performance score levels.',
            levelCountMax: 'You cannot define more than {{max}} performance score levels.',
            thresholdsUnique: 'Minimum score thresholds must be unique.',
            thresholdsDescending:
                'Minimum score thresholds must be strictly decreasing from highest to lowest.',
            lowestThresholdZero:
                'The lowest performance score level must have a minimum score of 0.',
        },
        delete: {
            title: 'Delete level "{{name}}"?',
            warning: 'This action is irreversible and applies retroactively.',
            impactSummary: '{{count}} evaluation is linked to this level and will be reassigned.',
            impactSummary_other:
                '{{count}} evaluations are linked to this level and will be reassigned.',
            numericScoresNote:
                'Some evaluations have a numeric score; all of them will be reassigned to the selected level.',
            replaceWith: 'Replace with',
            replacePlaceholder: 'Select a replacement level',
            confirm: 'Delete permanently',
            deleted: 'Performance score level deleted',
            deleteError: 'Error while deleting the performance score level',
        },
    },
    employeePortalCompetencies: {
        title: 'What the employee sees of their competencies',
        subtitle:
            'In their own portal, an employee can see the competencies they master and their evolution journey. You decide whether they see them, and from when.',
        showLabel: 'The employee sees the levels their {{managerLabel}} assessed them at',
        showHelp:
            'If it is closed, the employee portal shows nothing of their competencies or of their evolution journey.',
        timingLegend: 'From when the employee sees them',
        timing: {
            onSubmission: 'As soon as their {{managerLabel}} submits the evaluation',
            afterTheMeeting:
                'Once the evaluation meeting has been held, so the {{managerLabel}} speaks first',
        },
        saved: 'What the employee sees of their competencies has been updated',
        saveError: 'Error while saving what the employee sees of their competencies',
        loading: 'Loading what the employee sees of their competencies…',
        loadError: 'Unable to load what the employee sees of their competencies.',
        retry: 'Try again',
    },
    translations: {
        title: 'Competency translations',
        noLanguages:
            'No translation language configured. Add languages in the organization settings.',
        autoTranslate: 'Auto-translate',
        autoTranslateConsent: {
            title: 'Send content to an external service?',
            message:
                'Auto-translate sends the source competency, profile, group, level, question and option text to an external third-party translation service (api.mymemory.translated.net) outside Amélio. Do not use it for confidential content. Do you want to continue?',
            confirm: 'Send and translate',
        },
        translating: 'Translating…',
        progress: '{{filled}}/{{total}} fields translated',
        placeholder: 'Translation…',
        empty: '(empty)',
        save: 'Save',
        saving: 'Saving…',
        saved: 'Translations saved',
        saveError: 'Error while saving the translations',
        loadError: 'Unable to load the translations.',
        autoTranslated: 'Translations generated',
        levelsSection: 'Proficiency levels',
    },
    competencyProfilesAdmin: {
        title: 'Competency Profiles',
        subtitle: 'Easily assign competency profiles to your employees in a guided way',
        noCreatePermissionTitle: 'Permission required',
        noCreatePermissionTooltip:
            'Creating a profile requires the Manage Competencies permission. Contact your administrator.',
        searchPlaceholder: 'Search employees...',
        batchAssignment: 'Bulk assignment',
        noJobDepartment: 'No job title or department',
        loadError: 'Unable to load the employees.',
        retry: 'Retry',
        emptyTitle: 'No employees',
        emptyDescription: 'No employee matches your search or filters.',
        filters: {
            attributePlaceholder: 'Filter by attribute',
        },
        sections: {
            pending: 'Pending assignment',
            pendingCount: '{{count}} employees without an assigned profile',
            pendingCount_one: '{{count}} employee without an assigned profile',
            pendingCount_other: '{{count}} employees without an assigned profile',
            assigned: 'Assigned profiles',
            assignedCount: '{{count}} employees with an assigned profile',
            assignedCount_one: '{{count}} employee with an assigned profile',
            assignedCount_other: '{{count}} employees with an assigned profile',
        },
        tile: {
            noProfile: 'No profile',
        },
        back: 'Back',
        anonymous: 'Unnamed employee',
        choice: {
            title: 'Choose your approach',
            subtitle: 'How would you like to assign a competency profile to {{name}}?',
            selectExisting: 'Select an existing profile',
            selectExistingDescription: 'Choose from predefined profiles',
            createGuided: 'Create a profile step by step',
            createGuidedDescription: 'Create a custom profile guided step by step',
            copyFromEmployee: 'Or copy another employee’s profile',
            copyTitle: 'Copy an employee’s profile',
            copyHelper: 'The chosen employee’s profile will be assigned to {{name}}.',
            copyPlaceholder: 'Choose an employee',
            copyConfirm: 'Copy the profile',
            copyEmpty: 'No other employee has a profile to copy.',
        },
        selector: {
            title: 'Edit {{name}}’s profile',
            subtitle: 'Select a profile, then adjust the competencies for this employee.',
            assignTitle: 'Select a competency profile',
            assignSubtitle: 'Choose a predefined profile to assign to {{name}}.',
            currentSubtitle:
                '<encircled>Current</encircled> competency profile of <employee>{{name}}</employee>: what is expected in their position.',
            targetSubtitle:
                'Competency profile required for the <encircled>target position</encircled> of <employee>{{name}}</employee>.',
            searchPlaceholder: 'Search for a profile…',
            profilesHeading: 'Available profiles',
            profilesEmpty: 'No profile available.',
            createNewTitle: 'Create a new profile',
            createNewDescription: 'Create a custom profile with the guided assistant.',
            skillCount: '{{count}} competencies',
            skillCount_one: '{{count}} competency',
            skillCount_other: '{{count}} competencies',
            priorityCount: '{{count}} priority',
            priorityCount_one: '{{count}} priority',
            priorityCount_other: '{{count}} priority',
            selectAnother: 'Choose another profile',
            competenciesTitle: 'Profile competencies',
            priorityBadge: 'Priority',
            alreadyHeld: 'Already in current profile',
            adjustedFor: 'Adjusted for {{name}}',
            remove: 'Remove',
            restore: 'Restore',
            addedTitle: 'Additional competencies',
            addedCount: '+{{count}}',
            addCompetencies: 'Add other competencies',
            groupCount: '{{count}} competencies',
            groupCount_one: '{{count}} competency',
            groupCount_other: '{{count}} competencies',
            selectLevel: 'Select level',
            cancel: 'Cancel',
            confirm: 'Confirm assignment',
            save: 'Save',
            changeConfirmTitle: 'Confirm profile change',
            changeConfirmBody:
                '{{name}} will switch from the "{{current}}" profile to the "{{next}}" profile.',
            changeTargetConfirmBody:
                'The target position of {{name}} will switch from the "{{current}}" profile to the "{{next}}" profile. The adjustments made for this position will be cleared.',
            changeConfirmCancel: 'Cancel',
            changeConfirmConfirm: 'Confirm',
            deactivatedBanner: {
                title: 'Profile deactivated',
                body: 'The profile "{{name}}" is deactivated. Editing this employee\'s competencies is not possible until the profile is reactivated or unassigned.',
                goToProfiles: 'Manage profiles',
                unassign: 'Unassign this profile',
                noPermission: 'Contact your administrator to reactivate or unassign this profile.',
                unassignSuccess: 'Profile unassigned',
            },
        },
        addModal: {
            title: 'Additional competencies',
            titleWithProfile: 'Add competencies to “{{profile}}"',
            subtitle: 'Select additional competencies',
            searchPlaceholder: 'Search competencies...',
            allCategories: 'All categories',
            empty: 'No competency found.',
            inProfile: 'In profile',
            selected: 'Selected',
            allAdded: 'All added',
            selectGroup: 'Select group ({{count}})',
            selectGroup_one: 'Select group ({{count}})',
            selectGroup_other: 'Select group ({{count}})',
            groupSelected: 'Group selected ({{count}})',
            groupSelected_one: 'Group selected ({{count}})',
            groupSelected_other: 'Group selected ({{count}})',
            selectedCount: '{{count}} selected',
            selectedCount_one: '{{count}} selected',
            selectedCount_other: '{{count}} selected',
            cancel: 'Cancel',
            addSelection: 'Add selection',
            back: 'Back',
            added: 'Added',
            review: 'Review ({{count}})',
            review_one: 'Review ({{count}})',
            review_other: 'Review ({{count}})',
            confirm: 'Add ({{count}})',
            confirm_one: 'Add ({{count}})',
            confirm_other: 'Add ({{count}})',
            reviewTitle: 'Review',
            reviewTitleWithProfile: 'Review, {{profile}}',
            reviewSubtitle: 'Review before confirming',
            reviewSummary: '{{current}} current + {{new}} new = {{total}} total competencies',
            impactWarning:
                'This change will apply to all employees who have the “{{profile}}” profile assigned in their file.',
        },
        batch: {
            title: 'Batch assignment',
            stepEmployees: 'Step 1/3, Select employees',
            stepProfile: 'Step 2/3, Choose the profile',
            stepReview: 'Step 3/3, Review and confirm',
            modeAll: 'All without a profile',
            modeDepartment: 'By department',
            modeRole: 'By job title',
            modeByAttribute: 'By {{attribute}}',
            selectDepartment: 'Select a department',
            selectRole: 'Select a job title',
            noUnassigned: 'No employee without a profile',
            selectedCount: '<bold>{{count}}</bold> employee selected',
            selectedCount_one: '<bold>{{count}}</bold> employee selected',
            selectedCount_other: '<bold>{{count}}</bold> employees selected',
            continue: 'Continue',
            back: 'Back',
            profileLabel: 'Competency profile',
            profilePlaceholder: 'Select a profile…',
            profileSkillCount: '({{count}} competencies)',
            profileSkillCount_one: '({{count}} competency)',
            profileSkillCount_other: '({{count}} competencies)',
            alreadyHave: '{{count}} employees already have this profile',
            alreadyHave_one: '{{count}} employee already has this profile',
            alreadyHave_other: '{{count}} employees already have this profile',
            willReceive: '{{count}} employees will receive this profile',
            willReceive_one: '{{count}} employee will receive this profile',
            willReceive_other: '{{count}} employees will receive this profile',
            reviewAssignment: 'Review the assignment',
            summaryProfile: 'Profile',
            summaryAlready: 'Already have this profile',
            summaryReceive: 'Will receive this profile',
            reviewSentence:
                'After this operation, {{count}} employees will have the “{{profile}}” profile.',
            reviewSentence_one:
                'After this operation, {{count}} employee will have the “{{profile}}” profile.',
            reviewSentence_other:
                'After this operation, {{count}} employees will have the “{{profile}}” profile.',
            newBadge: 'New',
            assigning: 'Assigning… {{percent}}%',
            confirm: 'Confirm the assignment ({{count}})',
        },
        toast: {
            profileAssigned: 'Profile assigned to {{name}}.',
            customizationSaved: 'Competencies updated for {{name}}.',
            batchAssigned: 'Profile assigned to {{count}} employees.',
            batchAssigned_one: 'Profile assigned to {{count}} employee.',
            batchAssigned_other: 'Profile assigned to {{count}} employees.',
            copyNoProfile: 'The source employee has no profile assigned.',
        },
    },
    questionHelp: {
        button: 'Help',
        title: 'Writing a good question',
        intro: 'Questions are used to assess your people. Favor situational questions: describe concrete, graduated situations.',
        whyTitle: 'Why situations?',
        why: 'By quickly recognizing which situation matches an employee, your {{managerPluralLabel}} assess them fast and without bias, in a consistent way across every team.',
        goalTitle: 'The goal',
        goal: 'Reduce gaps between teams so everyone evaluates the same way.',
        exampleTitle: 'Here is how your {{managerPluralLabel}} will see the question',
        example: {
            prompt: 'Marc simplifies information without losing what matters.',
            option1: 'Simplifies faithfully, without losing anything important',
            option2: 'Simplifies well, loses a few secondary nuances',
            option3: 'Oversimplifies, the meaning gets distorted',
            option4: 'Simplifies so much the information becomes false',
        },
    },
};
